var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#70797B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.2C5.91312 1.2 2.60002 4.51309 2.60002 8.6C2.60002 11.2468 3.99053 13.4204 6.10239 14.6854C6.33893 14.8272 6.56185 15.0002 6.75981 15.2H9.40002V11.6H8.00002C7.66865 11.6 7.40002 11.3314 7.40002 11C7.40002 10.6686 7.66865 10.4 8.00002 10.4H10H12C12.3314 10.4 12.6 10.6686 12.6 11C12.6 11.3314 12.3314 11.6 12 11.6H10.6V15.2H13.2402C13.4382 15.0002 13.6611 14.8272 13.8977 14.6854C16.0095 13.4204 17.4 11.2468 17.4 8.6C17.4 4.51309 14.0869 1.2 10 1.2ZM12.5107 16.4H10H7.48933C7.56075 16.6364 7.60002 16.8867 7.60002 17.1481V17.4C7.60002 18.1732 8.22683 18.8 9.00002 18.8H11C11.7732 18.8 12.4 18.1732 12.4 17.4V17.1481C12.4 16.8867 12.4393 16.6364 12.5107 16.4ZM1.40002 8.6C1.40002 3.85035 5.25038 0 10 0C14.7497 0 18.6 3.85035 18.6 8.6C18.6 11.7038 16.9568 14.2517 14.5143 15.7149C13.9498 16.0531 13.6 16.5932 13.6 17.1481V17.4C13.6 18.8359 12.436 20 11 20H9.00002C7.56408 20 6.40002 18.8359 6.40002 17.4V17.1481C6.40002 16.5932 6.05027 16.0531 5.48571 15.7149C3.04325 14.2517 1.40002 11.7038 1.40002 8.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.026ce540a323a2c48ba3cf1f4121dc0f.svg";
export { ForwardRef as ReactComponent };